<template>
  <div>
    <div>
      <div class="page-title-cont">
        <h1 class="wp-heading-inline">
          WPCal.io - {{ T__("WPCal Admins Settings") }}
        </h1>
        <AdminHeaderRight />
      </div>
      <SettingsMenu />
      <OnBoardingCheckList display_in="settings_admins" />
      <div class="col-cont settings-cont">
        <div
          class="col"
          style="width:unset; max-width: 100%; margin-right: 30px;"
        >
          <div style="font-size: 16px;padding: 5px 0; display:flex;">
            {{ T__("WPCal Admins") }}
            <PremiumInfoBadge
              style="margin: -10px 0px 0px 10px;"
              highlight_feature="wpcal_admins"
            >
              <em
                >Free: 1 admin user<br />Plus: 5 admin users<br />Pro: 10 admin
                users</em
              >
            </PremiumInfoBadge>
          </div>
          <div class="validation_errors_cont"></div>
          <table class="mbox settingAdmins">
            <tr>
              <td>Name</td>
              <td>
                Total Event Types<br /><span style="font-size: 11px;"
                  >incl. privately managed</span
                >
              </td>
              <td>Active<br />Event Types</td>
              <td>Upcoming<br />Bookings</td>
              <td>Calendar<br />Accounts</td>
              <td>'Add bookings to...'<br />calendar</td>
              <td>Conflict<br />calendars</td>
              <td>Zoom</td>
              <td>GoToMeeting</td>
              <td></td>
            </tr>
            <tr
              v-for="(admin_detail, index) in admin_users_details"
              :key="index"
              :class="{
                disabled: admin_detail.status == -1,
                'del-alert': show_delete_highlight(
                  'delete_highlight_admin_index',
                  index
                )
              }"
            >
              <td>
                <a
                  style="white-space:nowrap;"
                  :href="'user-edit.php?user_id=' + admin_detail.admin_user_id"
                  >{{ admin_detail.name }}</a
                >
              </td>
              <td>{{ admin_detail.services_count }}</td>
              <td>{{ admin_detail.services_active_count }}</td>
              <td>{{ admin_detail.bookings_upcoming_count }}</td>
              <td>{{ admin_detail.calendar_acccounts_count }}</td>
              <td>
                {{ admin_detail.add_bookings_to_calendar ? "Added" : "-" }}
              </td>
              <td>{{ admin_detail.conflict_calendars_count }}</td>
              <td>{{ admin_detail.zoom_meeting ? "Connected" : "-" }}</td>
              <td>
                {{ admin_detail.gotomeeting_meeting ? "Connected" : "-" }}
              </td>
              <td>
                <OverflowMenu
                  :menu_id="admin_detail.admin_user_id"
                  v-model="admin_overflow_menu_details"
                  popper_position="right"
                >
                  <a
                    class="menu-item del-hl"
                    style="color: rgb(232, 70, 83);"
                    @click="
                      may_show_admin_status_change_dialog(-2, admin_detail)
                    "
                    @mouseover="
                      set_mouseover_on_delete(
                        'delete_highlight_admin_index',
                        index,
                        true
                      )
                    "
                    @mouseleave="
                      set_mouseover_on_delete(
                        'delete_highlight_admin_index',
                        index,
                        false
                      )
                    "
                    >{{ T__("Delete this user") }}</a
                  >
                  <div class="menu-item" style="display:flex !important;">
                    <span style="color: #7c7d9c !important; font-size: 13px;">{{
                      T__("On/Off")
                    }}</span>
                    <OnOffSlider
                      style="margin-left:auto;"
                      v-if="
                        admin_detail.status == 1 || admin_detail.status == -1
                      "
                      :name="admin_detail.admin_user_id"
                      v-model="admin_detail.status"
                      true_value="1"
                      false_value="-1"
                      @prop-slider-value-changed="
                        may_show_admin_status_change_dialog(
                          $event,
                          admin_detail
                        )
                      "
                    />
                  </div>
                </OverflowMenu>
              </td>
            </tr>
            <tr>
              <td colspan="10">
                <button
                  style="margin: 10px;"
                  type="button"
                  class="wpc-btn primary sm"
                  @click="show_add_admin_model"
                >
                  {{ T__("Add WPCal Admin") }}
                </button>
              </td>
            </tr>
          </table>

          <AdminInfoLine :info_slugs="['wpcal_admin_feature_access_info']" />
        </div>
      </div>
    </div>
    <modal
      name="add_admin_model"
      height="auto"
      width="360px"
      style="z-index:9999;"
    >
      <div class="modal_close_cont">
        <button @click="$modal.hide('add_admin_model')"></button>
      </div>
      <div class="mbox bg-light shadow">
        <div class="form">
          <div class="wpc-form-row">
            <label class="mb10" style="text-align:center;">{{
              T__("Select WP user to add as a WPCal admin")
            }}</label>

            <TypeToSelect
              v-model="add_wp_admin_id"
              :options="wp_admins_to_add_as_options"
              label_field="user_email"
              value_field="ID"
            >
              <template v-slot:selected-option="option">
                <div class="profile-details">
                  <img
                    v-if="option.profile_picture"
                    :src="option.profile_picture"
                    width="30"
                    style="border-radius:50%;"
                  />
                  <div>
                    <div class="txt-h5">{{ option.display_name }}</div>
                    <div class="txt-help">{{ option.user_email }}</div>
                  </div>
                </div>
              </template>
              <template v-slot:option="option">
                <div class="profile-details">
                  <img
                    v-if="option.profile_picture"
                    :src="option.profile_picture"
                    width="30"
                    style="border-radius:50%;"
                  />
                  <div>
                    <div class="txt-h5">{{ option.display_name }}</div>
                    <div class="txt-help">{{ option.user_email }}</div>
                  </div>
                </div>
              </template></TypeToSelect
            >
            <div class="txt-help" style="padding-top:5px;">
              Contributors and other users with edit_posts capabilities will be
              listed above.
            </div>
            <button
              type="button"
              class="wpc-btn primary md mt20"
              @click="add_wpcal_admin"
            >
              {{ T__("Add user as WPCal admin") }}
            </button>
          </div>
        </div>
      </div>
    </modal>
    <!-- <v-dialog /> -->
  </div>
</template>

<script>
import SettingsMenu from "@/components/admin/SettingsMenu.vue";
import OnBoardingCheckList from "@/components/admin/OnBoardingCheckList.vue";
import TypeToSelect from "@/components/form_elements/TypeToSelect.vue";
import OnOffSlider from "@/components/form_elements/OnOffSlider.vue";
import OverflowMenu from "@/components/form_elements/OverflowMenu.vue";
import axios from "axios";

import { createPopper } from "@popperjs/core";

export default {
  components: {
    SettingsMenu,
    TypeToSelect,
    OnOffSlider,
    OverflowMenu,
    OnBoardingCheckList
  },
  data() {
    return {
      document_title: "WPCal Admins ‹ Settings",
      admin_users_details: [],
      wp_admins_to_add: [],
      add_wp_admin_id: null,
      admin_overflow_menu_details: {
        open_menu_id: null,
        popper_instance: null
      },
      delete_highlight_admin_index: null
    };
  },
  computed: {
    wp_admins_to_add_as_options() {
      // let results = [];
      // return results;

      return this.wp_admins_to_add;
    }
  },
  methods: {
    load_page() {
      this.get_wpcal_admin_users_details();
    },
    async get_wpcal_admin_users_details() {
      let wpcal_request = {};
      let action = "get_wpcal_admin_users_details";
      wpcal_request[action] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      await axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          if (
            response.data &&
            response.data[action].hasOwnProperty("admin_users_details")
          ) {
            this.admin_users_details =
              response.data[action].admin_users_details;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    get_wp_admins_to_add() {
      let wpcal_request = {};
      let action = "get_wp_admins_to_add";
      wpcal_request[action] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          //console.log(response);
          if (
            response.data &&
            response.data[action].hasOwnProperty("wp_admins_to_add")
          ) {
            this.wp_admins_to_add = response.data[action].wp_admins_to_add;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    add_wpcal_admin() {
      let wpcal_request = {};
      let action_add_wpcal_admin = "add_wpcal_admin";
      wpcal_request[action_add_wpcal_admin] = {
        admin_data: {
          admin_user_id: this.add_wp_admin_id,
          admin_type: "administrator"
        }
      };

      let action_get_wpcal_admins = "get_wpcal_admin_users_details";
      wpcal_request[action_get_wpcal_admins] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(
            response.data[action_add_wpcal_admin],
            {
              success_msg: "Admin Added."
            }
          );

          if (
            response.data &&
            response.data[action_get_wpcal_admins].hasOwnProperty(
              "admin_users_details"
            )
          ) {
            this.admin_users_details =
              response.data[action_get_wpcal_admins].admin_users_details;
            this.event_bus.$emit(
              "may_update_onboarding_checklist_notice",
              "add_wpcal_admin"
            );
          }
        })
        .catch(error => {
          console.log(error);
        });
      this.$modal.hide("add_admin_model");
    },
    enable_wpcal_admin(admin_user_id) {
      let wpcal_request = {};
      let action_enable_wpcal_admin = "enable_wpcal_admin";
      wpcal_request[action_enable_wpcal_admin] = {
        admin_user_id: admin_user_id
      };

      let action_get_wpcal_admins = "get_wpcal_admin_users_details";
      wpcal_request[action_get_wpcal_admins] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(
            response.data[action_enable_wpcal_admin],
            {
              success_msg: "Admin enabled."
            }
          );

          if (
            response.data &&
            response.data[action_get_wpcal_admins].hasOwnProperty(
              "admin_users_details"
            )
          ) {
            this.admin_users_details =
              response.data[action_get_wpcal_admins].admin_users_details;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    disable_wpcal_admin(admin_user_id) {
      let wpcal_request = {};
      let action_disable_wpcal_admin = "disable_wpcal_admin";
      wpcal_request[action_disable_wpcal_admin] = {
        admin_user_id: admin_user_id
      };

      let action_get_wpcal_admins = "get_wpcal_admin_users_details";
      wpcal_request[action_get_wpcal_admins] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(
            response.data[action_disable_wpcal_admin],
            {
              success_msg: "Admin disabled."
            }
          );

          if (
            response.data &&
            response.data[action_get_wpcal_admins].hasOwnProperty(
              "admin_users_details"
            )
          ) {
            this.admin_users_details =
              response.data[action_get_wpcal_admins].admin_users_details;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    delete_wpcal_admin(admin_user_id) {
      let wpcal_request = {};
      let action_delete_wpcal_admin = "delete_wpcal_admin";
      wpcal_request[action_delete_wpcal_admin] = {
        admin_user_id: admin_user_id
      };

      let action_get_wpcal_admins = "get_wpcal_admin_users_details";
      wpcal_request[action_get_wpcal_admins] = "dummy__";

      let post_data = {
        action: "wpcal_process_admin_ajax_request",
        wpcal_request: wpcal_request
      };
      axios
        .post(window.wpcal_ajax.ajax_url, post_data)
        .then(response => {
          this.notify_single_action_result(
            response.data[action_delete_wpcal_admin],
            {
              success_msg: "Admin deleted."
            }
          );

          if (
            response.data &&
            response.data[action_get_wpcal_admins].hasOwnProperty(
              "admin_users_details"
            )
          ) {
            this.admin_users_details =
              response.data[action_get_wpcal_admins].admin_users_details;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    async may_show_admin_status_change_dialog(status, admin_detail) {
      const allowed_status = [1, -1, -2, "1", "-1", "-2"];
      if (allowed_status.indexOf(status) == -1) {
        return;
      }

      if (status != 1) {
        //load new data to get new service and bookings stats for the admins
        let triggered_admin_user_id = admin_detail.admin_user_id;
        //find the same admin
        await this.get_wpcal_admin_users_details(); //Load new data
        let found_admin_details = this.admin_users_details.find(
          _admin_details =>
            _admin_details.admin_user_id == triggered_admin_user_id
        );
        if (!found_admin_details) {
          return;
        }
        admin_detail = found_admin_details;
      }

      if (status != 1) {
        this.admin_overflow_menu_details.open_menu_id = null;
      }

      if (status == 1) {
        this.enable_wpcal_admin(admin_detail.admin_user_id);
        return;
      }

      let status_action_str = this.T__("enable");
      let status_action_str_ing = this.T__("enabling");
      let status_action_str_ed = this.T__("enabled");
      let button_str = this.T__("Enable");
      let detail_str = "";

      let services_active_count = admin_detail.services_active_count;
      let bookings_upcoming_count = admin_detail.bookings_upcoming_count;

      let allow_disable_delete = true;
      let not_allowed_str = "";
      if (
        services_active_count > 0 ||
        bookings_upcoming_count > 0 ||
        admin_detail.admin_user_id ==
          this.$store.getters.get_current_admin_details.id
      ) {
        allow_disable_delete = false;
      }

      if (status == -1) {
        status_action_str = this.T__("disable");
        status_action_str_ing = this.T__("disabling");
        status_action_str_ed = this.T__("disabled");
        button_str = this.T__("Yes, disable admin.");
      } else if (status == -2) {
        status_action_str = this.T__("delete");
        status_action_str_ing = this.T__("deleting");
        status_action_str_ed = this.T__("deleted");
        button_str = this.T__("Yes, delete admin.");
      }

      if (!allow_disable_delete) {
        if (services_active_count > 0) {
          not_allowed_str +=
            "<li>" +
            this.T__(
              "Reassign the Event types to another admin or disable the event types."
            ) +
            "</li>";
        }
        if (bookings_upcoming_count > 0) {
          if (not_allowed_str) {
            not_allowed_str += "<br>";
          }
          not_allowed_str +=
            "<li>" +
            this.T__(
              "Reschedule the bookings with another host (if possible) or cancel the bookings."
            ) +
            "</li>";
        }

        if (
          admin_detail.admin_user_id ==
          this.$store.getters.get_current_admin_details.id
        ) {
          if (not_allowed_str) {
            not_allowed_str += "<br>";
          }
          not_allowed_str +=
            "<li>" +
            this.T__(
              "Ask another WPCal admin to " + status_action_str + " you."
            ) +
            "</li>";
        }

        if (not_allowed_str) {
          not_allowed_str =
            "<br><br>" +
            this.T__(
              "Please do the following before " +
                status_action_str_ing +
                " the admin."
            ) +
            "<br>" +
            "<ul class='bull'>" +
            not_allowed_str +
            "</ul>";
        }
      }

      let final_title = "";
      let final_modal_str = "";
      let final_buttons = [];
      let no_self_disable_delete_str = "";

      if (
        !allow_disable_delete &&
        admin_detail.admin_user_id ==
          this.$store.getters.get_current_admin_details.id
      ) {
        no_self_disable_delete_str =
          '<div class="error-box center mb20">You cannot ' +
          status_action_str +
          " yourself.</div>";
      }

      final_modal_str +=
        no_self_disable_delete_str +
        this.Tsprintf(
          /* translators: 1: number 2: number */
          this.T__(
            "This admin is having %1$s active Event types and %2$s upcoming bookings."
          ),
          services_active_count,
          bookings_upcoming_count
        ) +
        not_allowed_str;

      if (allow_disable_delete) {
        let additional_info = "";

        let except_calendars_tp_account_added =
          admin_detail.zoom_meeting || admin_detail.gotomeeting_meeting;

        if (status == -1) {
          if (admin_detail.calendar_acccounts_count > 0) {
            additional_info +=
              "<li>" + this.T__("Calendars syncing will be paused.") + "</li>";
          }
          if (except_calendars_tp_account_added) {
            additional_info +=
              "<li>" +
              this.T__(
                "All integrations will be deactivated temporarily and activated automatically when you enable this admin."
              ) +
              "</li>";
          }
        } else if (status == -2) {
          if (
            admin_detail.calendar_acccounts_count > 0 &&
            except_calendars_tp_account_added
          ) {
            additional_info +=
              "<li>" +
              this.T__("Calendars and other integrations will be removed.") +
              "</li>";
          } else if (admin_detail.calendar_acccounts_count > 0) {
            additional_info +=
              "<li>" +
              this.T__("Calendar integrations will be removed.") +
              "</li>";
          } else if (except_calendars_tp_account_added) {
            additional_info +=
              "<li>" + this.T__("All integrations will be removed.") + "</li>";
          }
        }

        additional_info = additional_info
          ? "<br><ul class='bull'>" + additional_info + "</ul>"
          : "";

        final_modal_str += additional_info;

        final_buttons[final_buttons.length] = {
          title: button_str,
          class:
            status_action_str == "delete" || status_action_str == "disable"
              ? "vue-dialog-button dialog-red-btn"
              : "",
          handler: () => {
            if (status == -1) {
              this.disable_wpcal_admin(admin_detail.admin_user_id);
            } else if (status == -2) {
              this.delete_wpcal_admin(admin_detail.admin_user_id);
            }
            this.$modal.hide("dialog");
          }
        };

        final_title = this.Tsprintf(
          /* translators: 1: turn on off 2: html-tag-open 3: html-tag-open 4: event type name */
          this.T__("%1$s %2$s admin?"),
          status_action_str == "delete" ? "Delete" : "Disable",
          admin_detail.name
        );
      } else {
        final_title = this.Tsprintf(
          /* translators: 1: turn on off 2: html-tag-open 3: html-tag-open 4: event type name */
          this.T__("%2$s %4$s %3$s admin cannot be %1$s."),
          status_action_str_ed,
          "<strong>",
          "</strong>",
          admin_detail.name
        );
      }
      //add cancel button
      final_buttons[final_buttons.length] = {
        title: allow_disable_delete ? this.T__("No, don't.") : this.T__("Okay"),
        default: true, // Will be triggered by default if 'Enter' pressed.
        handler: () => {
          this.load_page();
          this.$modal.hide("dialog");
        }
      };

      this.$modal.show("dialog", {
        title: final_title,
        text: final_modal_str,
        buttons: final_buttons
      });
    },
    show_add_admin_model() {
      this.get_wp_admins_to_add();
      this.add_wp_admin_id = null;
      this.$modal.show("add_admin_model");
    }
  },
  mounted() {
    this.load_page();
  }
};
</script>

<style scoped>
#nav a {
  position: relative;
}
#nav a.router-link-exact-active {
  text-decoration: underline;
}
table.settingAdmins {
  width: 100%;
  margin: 5px 0 5px;
  border-collapse: collapse;
}
table.settingAdmins td {
  padding: 7px;
  border: 1px solid #d8dbe7;
  font-size: 14px;
}
table.settingAdmins tr:hover td {
  background-color: #eff3fb;
}
table.settingAdmins tr.del-alert td {
  background-color: #ffecee;
}
table.settingAdmins tr td:last-child {
  padding: 0;
  width: 24px;
  position: relative;
}
table.settingAdmins tr td:last-child .overflow-options-cont {
  right: 2px;
  margin-top: -6px;
}

table.settingAdmins tr:first-child:hover td,
table.settingAdmins tr:last-child:hover td {
  background-color: #fff;
}
table.settingAdmins tr:first-child td {
  font-family: "RubikMed" !important;
  vertical-align: bottom;
  font-size: 13px;
}
table.settingAdmins tr.disabled {
  background-color: #f7f7f7;
}
table.settingAdmins tr.disabled td:not(:last-child) {
  opacity: 0.4;
}
</style>
<style>
#nav a {
  position: relative;
}
#nav a.router-link-exact-active {
  text-decoration: underline;
}
[data-modal="add_admin_model"] .ttf-v-selector {
  background-color: #fff;
}
</style>
